import {
    Button,
    Col,
    Form,
    Input,
    Modal,
    Row,
    Upload,
    Image,
    Select
} from "antd";
import React, { useEffect, useState } from "react";
import "react-phone-input-2/lib/style.css";

import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import SingleImageUpload from "../../components/SingleImageUpload";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

const AddForm = ({ api, show, hide, data, refresh }) => {
    const [form] = Form.useForm();
    const { request } = useRequest();
    const [loading, setLoading] = useState(false);
    const { TextArea } = Input;
    useEffect(() => {
        if (data) {
            form.setFieldsValue({
                category: data.category,
                faqs: [{ question: data.question, answer: data.answer }],
            });
        } else {
            form.setFieldsValue({
                category: undefined,
                faqs: [{ question: "", answer: "" }],
            });
        }
    }, [data]);


    const onCreate = async () => {
        try {
            const values = await form.validateFields();

            const payload = values.faqs.map(faq => ({
                question: faq.question,
                answer: faq.answer,
                category: values.category,
            }));

            request({
                url: data?._id ? `${api.faqAddMultiple}/${data._id}` : api.faqAddMultiple,
                method: data?._id ? "PUT" : "POST",
                data: data?._id ? payload[0] : { faqs: payload },
                onSuccess: (res) => {
                    setLoading(false);
                    ShowToast(res.message, Severty.SUCCESS);
                    hide();
                    refresh();
                    form.resetFields();
                },
                onError: (err) => {
                    setLoading(false);
                    ShowToast(err?.response?.data?.message || "Something went wrong", Severty.ERROR);
                },
            });
        } catch (err) {
            setLoading(false);
            console.error("Validation failed:", err);
        }
    };


    return (
        <Modal
            open={show}
            width={800}
            okText="Save"
            onCancel={hide}
            onOk={onCreate}
            confirmLoading={loading}
            centered
            className="tab_modal"
        >
            <Form
                form={form}
                id="multiFaqForm"
                layout="vertical"
                initialValues={{ faqs: [{ question: "", answer: "" }] }}
            >
                <h4 className="modal_title_cls">
                    {data?._id ? "Edit FAQ" : "Add FAQs"}
                </h4>


                <Form.Item
                    label="Category"
                    name="category"
                    rules={[{ required: true, message: "Please select a category" }]}
                >
                    <Select placeholder="Select FAQ Category">
                        <Select.Option value="MP Duties">MP Duties</Select.Option>
                        <Select.Option value="Community Programs">Community Programs</Select.Option>
                        <Select.Option value="MP Announcements & Reports">MP Announcements & Reports</Select.Option>
                        <Select.Option value="Issue reporting & resolution">Issue reporting & resolution</Select.Option>
                        <Select.Option value="Events & public appearances">Events & public appearances</Select.Option>
                    </Select>
                </Form.Item>

                <Form.List name="faqs" rules={[{
                    validator: async (_, faqs) => {
                        if (!faqs || !faqs.length) {
                            return Promise.reject(new Error("Please add at least one FAQ"));
                        }
                    }
                }]}>
                    {(fields, { add, remove }) => (
                        <>
                            {fields.map(({ key, name, ...restField }) => (
                                <div key={key} className="faq-group">
                                    <Row gutter={16}>
                                        <Col span={11}>
                                            <Form.Item
                                                {...restField}
                                                name={[name, "question"]}
                                                label="Question"
                                                rules={[{ required: true, message: "Please enter the question" }]}
                                            >
                                                <TextArea placeholder="Enter FAQ question" />
                                            </Form.Item>
                                        </Col>
                                        <Col span={11}>
                                            <Form.Item
                                                {...restField}
                                                name={[name, "answer"]}
                                                label="Answer"
                                                rules={[{ required: true, message: "Please enter the answer" }]}
                                            >
                                                <TextArea placeholder="Enter answer" />
                                            </Form.Item>
                                        </Col>
                                        <Col span={2} style={{ display: "flex", alignItems: "center", marginTop: 26 }}>
                                            <div className="minus-button-new">
                                                <MinusCircleOutlined onClick={() => remove(name)} />
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            ))}
                            <Form.Item>
                                <Button onClick={() => add()} block icon={<PlusOutlined />}>
                                    Add another Question
                                </Button>
                            </Form.Item>
                        </>
                    )}
                </Form.List>
            </Form>
        </Modal>
    );
};


export default AddForm;
